export const waitForModalAnimation = (func: () => void, delay: number = 300) => {
  setTimeout(func, delay);
};
